'use client';

import React from "react";
import { Phone, MapPin, Mail } from "lucide-react";
import { initialsOf, formatPhone } from "../internals";

export const IndividualRow = ({ individual, onClick }) => {
  const inactive = individual.status === "inactive";
  return (
    <button
      type="button"
      data-testid={`individual-row-${individual.id}`}
      onClick={onClick}
      className="flex w-full items-center gap-3 rounded-lg border border-zinc-200 bg-white px-3 py-3 text-left transition-colors hover:bg-zinc-50"
    >
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-rose-600 text-sm font-semibold text-white">
        {initialsOf(individual.name)}
      </span>
      <span className="min-w-0 flex-1">
        <span className="flex items-center gap-2">
          <span className="truncate text-sm font-semibold text-zinc-900">{individual.name}</span>
          {inactive && (
            <span className="rounded-full bg-zinc-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-zinc-500">
              Inactive
            </span>
          )}
        </span>
        <span className="mt-0.5 flex flex-wrap items-center gap-x-3 gap-y-0.5 text-xs text-zinc-500">
          {individual.phone && (
            <span className="inline-flex items-center gap-1"><Phone size={11} />{formatPhone(individual.phone)}</span>
          )}
          {individual.city && (
            <span className="inline-flex items-center gap-1"><MapPin size={11} />{individual.city}</span>
          )}
          {individual.email && (
            <span className="inline-flex items-center gap-1"><Mail size={11} />{individual.email}</span>
          )}
        </span>
      </span>
    </button>
  );
};
